import { render } from "./ControlBar.vue?vue&type=template&id=c4d7684c&scoped=true"
import script from "./ControlBar.vue?vue&type=script&lang=js"
export * from "./ControlBar.vue?vue&type=script&lang=js"

import "./ControlBar.vue?vue&type=style&index=0&id=c4d7684c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d7684c"]])

export default __exports__